<template>
  <div class="warp">
    <div class="content" v-if="ministate">
        <div class="title">智慧享联</div>
        <div class="infor">
          <div class="sub-title">房地产、物业企业信息化解决方案服务商</div>
          <div class="content-intro">深圳市智慧享联网络技术有限公司，成立于2015年，是金地集团全资互联网科技公司，是中国领先的房地产、物业企业信息化解决方案服务商。目前已服务约2000个社区，覆盖100余座大中城市，合约服务面积近6亿平米，服务客户500余万人。 智慧享联统筹搭建了智慧社区平台（智慧门禁、智慧车场、智慧安防与监控、智慧网络）、智能家居平台与享家社区服务平台等基础物业服务及全产业链服务新业务一起，组成了“智享生态圈”。</div>
          <div class="qr-btn">
              <div class="content-qr">
                <div class="content-qr-text-wrap">
                  <div class="content-qr-text"><a class="content-qr-text" href="https://ienjoys.com/index.html">进入网站</a></div>
                </div>
                <div class="content-qr-pic"></div>
              </div>
          </div>
          <div class="content-logo"></div>
          <!-- <img  src=""> -->
        </div>
    </div>
    <div class="mini-content" v-else>
        <div class="mini-content-logo"></div>
        <!-- <img  src=""> -->
        <div class="mini-title">智慧享联</div>
        <div class="mini-sub-title">房地产、物业企业信息化解决方案服务商</div>
        <div class="mini-content-intro">深圳市智慧享联网络技术有限公司，成立于2015年，是金地集团全资互联网科技公司，是中国领先的房地产、物业企业信息化解决方案服务商。目前已服务约2000个社区，覆盖100余座大中城市，合约服务面积近6亿平米，服务客户500余万人。 智慧享联统筹搭建了智慧社区平台（智慧门禁、智慧车场、智慧安防与监控、智慧网络）、智能家居平台与享家社区服务平台等基础物业服务及全产业链服务新业务一起，组成了“智享生态圈”。</div>
        <div class="mini-btn">
          <!-- <img class="mini-btn-pic" src="" > -->
          <div class="mini-btn-text"><a class="content-qr-text" href="https://ienjoys.com/index.html">点击进入网站</a></div> 
        </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex"
export default {
  components: {

    },
    data() {
        return {

        };
    },
    computed: {
      ...mapState(["screenWidth"]),
      ministate() {
          if (this.screenWidth >= 768) {
            return true 
          }else {
            return false
          }
      }
    },
}
</script>

<style scoped>
.warp {
  height: 100%;
}

.content {
  position: relative;
  width: 6.25rem;
  margin: .63rem auto 0;
}

.title {
  font-size: .25rem;
  font-weight: 700;
  color: #606060;
  margin-bottom: .06rem;
  padding-left: .09rem;
  border-left: .05rem solid #ff742b;;
}

.infor {
  margin-left: .14rem;
}

.sub-title {
  font-size: .17rem;
  font-weight: 400;
  color: #a8a8a8;
  margin-bottom: .16rem;
}

.content-intro {
  width: 3.33rem;
  line-height: .15rem;
  font-size: .1rem;
  font-weight: 400;
  color: #a8a8a8;
  margin-bottom: .31rem;
}

.qr-btn {
  display: flex;
}

.content-qr {
  width: .86rem;
  height: .26rem;
  background: #ff7f3b;
  border-radius: .13rem;
  box-shadow: 0 .01rem .07rem 0 rgba(255,122,0,0.33); 
  font-size: .08rem;
  font-weight: 400;
  color: white;
  text-align: center;
  line-height: .26rem;
  overflow: hidden;
  transition: all 0.5s;
  margin-right: .31rem;
}

.content-qr-text {
  color: #ffffff;
}

.content-qr-text-wrap {
  width: .86rem;
  height: .26rem;
  display: flex;
  align-items: center;
  justify-content: center;
}

.content-qr-text-icon-ios {
  width: .1rem;
  height: .1rem;
  margin-right: .03rem;
  background-image: url(../imgs/icon-ios.png);
  background-size: 100% 100%;
  background-repeat: no-repeat;
}

.content-qr-text-icon-andro {
  width: .11rem;
  height: .11rem;
  margin-right: .03rem;
  background-image: url(../imgs/icon-android.png);
  background-size: 100% 100%;
  background-repeat: no-repeat;
}


.content-qr-pic {
  margin: 0 auto ;
  width: .53rem;
  height: .53rem;
  background: cornflowerblue;
}

.content-logo {
  position: absolute;
  top: .14rem;
  right: .35rem;
  width: 1.32rem;
  height: 1.32rem;
  background-image: url(../imgs/pc-zhxl.png);
  background-size: 100% 100%;
  background-repeat: no-repeat;
}

/* 移动端样式 */
.mini-content {
  position: relative;
  height: 100%;
  display:flex;
  flex-direction: column;
  align-items: center;
}

.mini-content-logo {
  width: 2.67rem;
  height: 2.67rem;
  margin: 1.57rem  0 .67rem;
  background-image: url(../imgs/mini-zhxl.png);
  background-size: 100% 100%;
  background-repeat: no-repeat;
}

.mini-title {
  font-size: .48rem;
  font-weight: 700;
  color: #606060;
  margin-bottom: .27rem;
}

.mini-sub-title {
  font-size: .36rem;
  font-weight: 400;
  color: #a8a8a8;
  margin-bottom: .27rem;
}

.mini-content-intro {
  width: 7.24rem;
  font-size: .36rem;
  font-weight: 400;
  color: #CCC7C1;
  margin-bottom: .27rem;
  line-height: .4rem;
}

.mini-btn {
  position: absolute;
  top: 10.5rem;
  width: 6.19rem;
  height: 1.24rem;
  background: #ff7f32;
  border-radius: 47px;
  box-shadow: 0 .03rem .13rem 0 rgba(255,122,0,0.33);
  display: flex;
  align-items: center;
  justify-content: center; 
}

.mini-btn-pic {
  width: .4rem;
  height: .4rem;
  background: cornsilk;
}

.mini-btn-text {
  font-size: .36rem;
  font-weight: 500;
  color: #ffffff;
}
</style>